import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigListHeader = _resolveComponent("ConfigListHeader")!
  const _component_ConfigListTable = _resolveComponent("ConfigListTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfigListHeader, {
      onShowAddCountryDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('show-add-country-dialog')))
    }),
    _createVNode(_component_ConfigListTable)
  ], 64 /* STABLE_FRAGMENT */))
}